import axios from "axios";

export const api = axios.create({
  baseURL: "https://golden-myrtle-thegeorgenikhil.koyeb.app/api",
});
